import React from "react";
import { cuFormat } from "../../../components/table/coreUiTable/Format";
import Table from "../../../components/table/coreUiTable/Table";
import { colHeaders, addGaps, customFn } from "../utils/dataForTables";

export const AppointmentAndGuestsTable = ({
  chartData: { data = [], columns = [], links = [] } = {}
}) => {
  let scopedSlots = {};

  if (data.length > 0) {
    addGaps(data, links);
    scopedSlots = {
      ...cuFormat({
        headers: colHeaders,
        columns,
        links,
        customFn: (header, value, rawValue) => customFn(header, value, rawValue)
      })
    };
  }

  return (
    <div className="dailyPulse__section" id="dailyPulseTable">
      <p className="title">Appointment & Guests</p>
      <Table
        table={{ data, colHeaders }}
        pagination={false}
        tableFilter={false}
        tableWrapperId="appAndGuests"
        scopedSlots={scopedSlots}
      />
    </div>
  );
};
